const DashboardFluxCompositionBar = ({ segments, emptyLabel, formatValue }) => {
  const total = segments.reduce((sum, segment) => sum + segment.value, 0);
  const displayValue = (value) =>
    formatValue ? formatValue(value) : value.toLocaleString();

  if (total <= 0) {
    return <p className="dashboard-chart-empty">{emptyLabel}</p>;
  }

  return (
    <div className="dashboard-composition">
      <div className="dashboard-composition-track" role="img">
        {segments.map((segment) => (
          <div
            key={segment.label}
            className="dashboard-composition-segment"
            style={{
              flexGrow: segment.value,
              flexBasis: 0,
              backgroundColor: segment.color,
            }}
            title={`${segment.label}: ${displayValue(segment.value)}`}
          />
        ))}
      </div>
      <ul className="dashboard-composition-legend">
        {segments.map((segment) => (
          <li key={segment.label} className="dashboard-composition-legend-item">
            <span
              className="dashboard-composition-swatch"
              style={{ backgroundColor: segment.color }}
            />
            <span className="dashboard-composition-legend-label">
              {segment.label}
            </span>
            <span className="dashboard-composition-legend-value">
              {displayValue(segment.value)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DashboardFluxCompositionBar;
